import { graphQLRequest } from '@atlassian/mpac-fetch-wrapper';
import { hooks, log } from '@atlassian/mpac-utils';
var GlobalInstallationConfig = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "GlobalInstallationConfig" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "cloudId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "filter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "GlobalInstallationConfigFilter" } }, directives: [] }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ecosystem" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "globalInstallationConfig" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "cloudId" }, value: { kind: "Variable", name: { kind: "Name", value: "cloudId" } } }, { kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "filter" } } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "value" }, arguments: [], directives: [] }] } }] } }] } }], loc: { start: 0, end: 405, source: { body: "# If you are making any change here\n# Do thoroughly read our graphql contribution guidelines\n# https://bitbucket.org/atlassian-marketplace/marketplace-frontend/src/master/docs/working-with-graphql.md\n\nquery GlobalInstallationConfig($cloudId: ID!, $filter: GlobalInstallationConfigFilter) {\n  ecosystem {\n    globalInstallationConfig(cloudId: $cloudId, filter: $filter) {\n      key\n      value\n    }\n  }\n}\n", name: "GraphQL request", locationOffset: { line: 1, column: 1 } } } };
export const getGlobalInstallationConfig = async (cloudId, gqlGatewayUrl) => {
  try {
    const {
      errors,
      data
    } = await graphQLRequest(gqlGatewayUrl, {
      query: GlobalInstallationConfig,
      variables: {
        cloudId
      }
    });
    if (errors !== null && errors !== void 0 && errors.length) {
      throw new Error(errors[0].message);
    }
    return data;
  } catch (error) {
    log.error("Error fetching global installation config for the cloud-id: ".concat(cloudId), JSON.stringify(error));
    throw error;
  }
};
export const useGlobalInstallationConfig = _ref => {
  let {
    cloudId,
    skip,
    gqlGatewayUrl
  } = _ref;
  const globalInstallationConfigPromise = () => getGlobalInstallationConfig(cloudId, gqlGatewayUrl);
  const {
    result: globalInstallationConfigResult,
    pending: globalInstallationConfigLoading,
    error: globalInstallationConfigError
  } = hooks.usePromise(globalInstallationConfigPromise, [gqlGatewayUrl], !skip);
  return {
    globalInstallationConfigResult,
    globalInstallationConfigLoading: skip ? false : globalInstallationConfigLoading,
    globalInstallationConfigError
  };
};